import {HttpConnection} from "../Designer/RequestCreator";
import {CalendarDto} from "shared/Generated/Dto/DataSources/CalendarDto";

export class CalendarController {
  private readonly route = `calendars/json`;

  public getCalendars(connectionId: string): Promise<CalendarDto[]> {
    return HttpConnection.getAsync(connectionId, `${this.route}/GetCalendars`) as Promise<CalendarDto[]>;
  }
}